import { render, staticRenderFns } from "./totalReport.vue?vue&type=template&id=a901c8f0&scoped=true"
import script from "./totalReport.vue?vue&type=script&lang=js"
export * from "./totalReport.vue?vue&type=script&lang=js"
import style0 from "./totalReport.vue?vue&type=style&index=0&id=a901c8f0&prod&lang=less"
import style1 from "./totalReport.vue?vue&type=style&index=1&id=a901c8f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a901c8f0",
  null
  
)

export default component.exports